angular.module('leanlaw').factory('originationDetailDefinitionByUser', ['$q', 'singleRequest', 'userService', function ($q, singleRequest, userService) {
  const cancel = params => {
    singleRequest.cancel('compensation');
  };
  const columns = [{
    id: 'user',
    label: 'User'
  }, {
    id: 'services',
    label: 'Collected Services',
    filter: 'amount',
    number: true
  }, {
    id: 'expenses',
    label: 'Collected Expenses',
    filter: 'amount',
    number: true
  }, {
    id: 'total',
    label: 'Collected Total',
    filter: 'amount',
    number: true
  }, {
    id: 'origination',
    label: 'Origination',
    filter: 'amount',
    number: true
  }, {
    id: 'percentage',
    label: 'Percentage',
    filter: 'percentage',
    number: true,
    total: false
  }];
  const userRows = users => users.map(user => ({
    id: user.user && user.user.id,
    label: `${user.user.name} (${user.user.initials})`,
    italic: true,
    values: {
      user: {
        value: user.user.initials || user.user.name
      },
      amount: {
        value: user.data.origination.originatorDebit
      },
      services: {
        value: user.data.collected.servicesTotal
      },
      expenses: {
        value: user.data.collected.expensesTotal
      },
      total: {
        value: user.data.collected.total
      },
      origination: {
        value: 0 /* calculated below */
      },
      percentage: {
        value: user.data.origination.percentage
      }
    }
  }));
  const filterChange = ({
    filter
  }) => {
    if (!filter.originationUser) {
      return {
        navigate: {
          id: 'origination-detail-matter'
        }
      };
    }
  };
  const load = async ({
    query,
    params,
    filter
  }) => {
    const request = {
      ...query,
      primary: 'clients',
      secondary: 'users',
      data: 'payments',
      status: 'all',
      scope: params.userId ? 'originating' : '-originating',
      scopeAccount: params.userId
    };
    const report = await singleRequest.apiCall('compensation').getReport(request);

    // create rows and subrows for group of users and items
    const rows = [];
    report.clients.forEach(client => {
      client.matters.forEach(matter => {
        rows.push({
          id: matter.matter.id,
          clientId: client.client.id,
          matterId: matter.matter.id,
          label: matter.matter.label,
          values: {
            user: {
              value: undefined
            },
            services: {
              value: matter.data.collected.servicesTotal
            },
            expenses: {
              value: matter.data.collected.expensesTotal
            },
            total: {
              value: matter.data.collected.total
            },
            origination: {
              value: 0 /* calculated below */
            },
            percentage: {
              value: matter.data.origination.percentage
            }
          },
          rows: userRows(matter.users)
        });
      });
    });

    // Calculate the origination column -- it is a summary of the users
    // origination share of each working attorney
    let extraTotal;
    if (params.userId) {
      let userTotal = 0;
      rows.forEach(client => {
        const userRow = client.rows.find(user => user.id === params.userId);
        if (!userRow) {
          return;
        }
        const percentage = userRow.values.percentage.value;
        client.rows.forEach(user => {
          user.values.origination.value = Math.round(user.values.services.value * percentage) / 100;
          client.values.origination.value += user.values.origination.value || 0;
          if (user.id === params.userId) {
            userTotal += user.values.origination.value || 0;
          }
        });
        client.rows = client.rows.filter(user => user.values.origination.value);
      });
      const originatingUser = await userService.get(params.userId);
      const initials = originatingUser.initials || originatingUser.name;
      extraTotal = {
        label: `Total from ${initials} worked`,
        values: {
          origination: {
            value: userTotal
          }
        }
      };
      columns.find(c => c.id === 'origination').label = `Origination (${initials})`;
    }
    return {
      rows,
      extraTotal
    };
  };
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'user',
      label: `Origination`,
      subrow: {
        label: 'Users',
        default: true,
        title: true
      },
      totals: {
        rows: true,
        totalLabelCells: 3
      },
      showFilters: {
        distribution: true,
        dateRange: true,
        originationUser: true
      },
      columns
    };
  };
  return {
    structure,
    load,
    cancel,
    filterChange
  };
}]);